import { call, put, takeLatest } from 'redux-saga/effects';
import Api from '../api';
import _ from 'lodash';


function* fetchPackage( action )
{
    try
    {
        const opts = action.opts;

        const pkg = yield call(
            Api.fetchPackage,
            action.packageName,
            _.get( opts, 'type', null ),
            _.get( opts, 'channel', null ),
            _.get( opts, 'signature', null )
        );

        yield put( { type: 'PACKAGE_FETCH_SUCCEEDED', pkg : pkg } );
    }
    catch( e )
    {
        console.error( e );
        yield put( { type: 'PACKAGE_FETCH_FAILED', message: e.message } );
    }
}


function* mySaga()
{
    yield takeLatest( 'PACKAGE_FETCH_REQUESTED', fetchPackage );
}

export default mySaga;




// WEBPACK FOOTER //
// ./src/lib/sagas/fetch-package.js